import * as React from 'react';
import groupBy from 'lodash-es/groupBy';
import { PeaksPoint, PeaksPeriod } from '../interfacesPeaks/PeaksJS';

export interface EventTotalsProps {
    pointEvents: Array<PeaksPoint>;
    periodEvents: Array<PeaksPeriod>;
}


export class EventTotals extends React.Component<EventTotalsProps> {
    constructor(props: EventTotalsProps) {
        super(props);
    }

    renderEventTypes = (eventTypeGroup): Array<React.ReactNode> => {
        const listItems: Array<React.ReactNode> = [];
        for (var property in eventTypeGroup) {
            const group: Array<PeaksPoint & PeaksPeriod> = eventTypeGroup[property];

            listItems.push(
                <li key={property} className="list-group-item col-xs-4">
                    <span className="badge badge-info">{group.length}</span>
                    {group[0].eventTypeName}
                </li>
            );
        }
        return listItems;
    }

    render() {
        const groupedPointEvents = groupBy(this.props.pointEvents, 'eventTypeId');
        const groupedPeriodEvents = groupBy(this.props.periodEvents, 'eventTypeId');

        const groupedAll = Object.assign({}, groupedPointEvents, groupedPeriodEvents);

        return (
            <>
                <h3 className="text-primary">Total Events</h3>
                <ul className="list-group">
                    {this.renderEventTypes(groupedAll)}
                </ul>
            </>
        );
    }
}
